import { render, staticRenderFns } from "./AccountButton.vue?vue&type=template&id=47dc8330&scoped=true"
import script from "./AccountButton.vue?vue&type=script&lang=js"
export * from "./AccountButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc8330",
  null
  
)

export default component.exports